import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  InputAdornment,
  Button,
  Chip,
  Tooltip,
  IconButton
} from '@material-ui/core';
import React, { Component } from 'react';
import { apiBatchRequest, apiPut, downloadReport } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import '../Reports/report.less';
import { DateFormat } from '../../constants/appConstants';
import moment from 'moment';
import PageHeader from '../common/PageHeader';
import { checkYearEndBonusValidations, EnhancedTableHead, GenerateAbsoluteURL, orderBy, UpdateColumnWithConfiguration } from '../../utils/helper';
import { getFormattedValues } from '../../utils/formatData';
import { employeeBonusSheet } from '../../constants/MockData';
import PageFilter from '../common/PageFilter';
import { controlType } from '../../constants/common';
import SaveIcon from '@material-ui/icons/Save';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import { cloneDeep } from 'lodash';
import ResetIcon from '@material-ui/icons/RestorePageOutlined';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteIcon from '@material-ui/icons/Delete';
import AssignmentIcon from '@material-ui/icons/Assignment';

export default class EmployeeEstimatedBonus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      originalDBEmployeeEstimatedBonus: [],
      employeeEstimatedBonus: [],
      departmentMasterData: [],
      accountCodeNameMasterData: [],
      marketMasterData: [],
      configuration: [],
      order: 'desc',
      orderBy: 'isEditable',
      selectedData: [],
      defaultSelectedData: [],
      openDialog: false,
      confirmationMessage: '',
      originalEmployeeEstimatedBonus: [],
      designationMasterData: [],
      updateData: {
        preferredName: ''
      },
      showReport: false,
      isFreezed: false,
      resetDefault: false,
      employeeMasterData: [],
      deletedEmployeeBonusId: []
    };

    this.baseState = this.state;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetMasterData();
  }

  GetMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'departmentMasterData'
      },
      {
        url: API_URL.Report.GetAccountCodeName,
        key: 'accountCodeNameMasterData'
      },
      {
        url: API_URL.Employee.GetDesignationMasterData,
        key: 'designationMasterData'
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      }
    ])
      .then(({ departmentMasterData, accountCodeNameMasterData, designationMasterData, marketMasterData }) => {
        this._asyncRequest = null;
        if (departmentMasterData.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        const selectedData = [];
        selectedData.push({
          key: 'startDate',
          selected: [{ startDate: moment().format(DateFormat) }]
        });

        this.setState({
          defaultSelectedData: selectedData,
          selectedData,
          departmentMasterData: departmentMasterData.data,
          accountCodeNameMasterData: accountCodeNameMasterData.data,
          designationMasterData: designationMasterData.data,
          marketMasterData: marketMasterData.data
        }, () => {
          this.GetEmployeeBonusEstimation(this.state.selectedData);
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  GetEmployeeBonusEstimation = (selectedData) => {
    let startDate = null;
    const marketName =
      selectedData.find((x) => x.key === 'marketName') || {};
    let marketId = null;
    if (
      marketName &&
      marketName.selected &&
      marketName.selected.length > 0
    ) {
      marketId = marketName.selected.map(x => x.marketId).join('|');
    }
    const startDateData =
      selectedData.find((x) => x.key === 'startDate') || {};
    if (
      startDateData &&
      startDateData.selected &&
      startDateData.selected.length > 0
    ) {
      startDate = startDateData.selected[0].startDate;
    }
    const params = {
      processYear: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(),
      marketId: marketId
    };
    const employeeParam = {
      processYear: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(),
      DepartmentId: 9
    };

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeBonusEstimation,
        key: 'employeeEstimatedBonus',
        params
      },
      {
        url: API_URL.Employee.GetEmployeeInformation,
        key: 'employeeMasterData',
        params: employeeParam
      }
    ])
      .then(({ employeeEstimatedBonus, employeeMasterData }) => {
        this._asyncRequest = null;
        if (employeeEstimatedBonus.success !== true) {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
        this.setState({
          originalDBEmployeeEstimatedBonus: orderBy(employeeEstimatedBonus.data || [], this.state.orderBy, this.state.order),
          originalEmployeeEstimatedBonus: orderBy(employeeEstimatedBonus.data || [], this.state.orderBy, this.state.order),
          employeeEstimatedBonus: orderBy(employeeEstimatedBonus.data || [], this.state.orderBy, this.state.order),
          configuration: employeeEstimatedBonus.config || [],
          isFreezed: (employeeEstimatedBonus.data || []).find(x => x.isFreezed === true)?.isFreezed || false,
          showReport: true,
          resetDefault: false,
          deletedEmployeeBonusId: [],
          employeeMasterData: employeeMasterData.data
        }, () => {
          const columns = this.getColumns(employeeEstimatedBonus.config || [], employeeEstimatedBonus.data || []);
          this.onControlChange(this.state.updateData.preferredName, 'preferredName', columns);
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === 'asc';
    const isRecentlyAddedRecord = this.state.employeeEstimatedBonus.find(x => x.isRecentlyAdded === true);
    let employeeEstimatedBonus = orderBy(this.state.employeeEstimatedBonus, property, isAsc ? 'desc' : 'asc');
    employeeEstimatedBonus = employeeEstimatedBonus.filter(x => x.isRecentlyAdded !== true);
    if (isRecentlyAddedRecord !== undefined) {
      employeeEstimatedBonus.unshift(isRecentlyAddedRecord);
    }
    this.setState({
      order: isAsc ? 'desc' : 'asc',
      orderBy: property,
      employeeEstimatedBonus
    });
  };

  onControlChange = (value, fieldName, configData) => {
    const { originalEmployeeEstimatedBonus, updateData } = this.state;
    let employeeEstimatedBonus = cloneDeep(originalEmployeeEstimatedBonus);
    updateData[fieldName] = value;
    configData.map(config => {
      if (config.filterConfig && config.filterConfig.controlType === controlType.TextBox && updateData[config.key]) {
        employeeEstimatedBonus = employeeEstimatedBonus.filter(x => x[config.key]?.toLowerCase().includes(updateData[config.key]?.toLowerCase()?.trim()) === true);
      }
      if (config.filterConfig && config.filterConfig.controlType === controlType.DropDown && config.filterConfig.displayFormat === 'MultiText' && updateData[config.key]) {
        employeeEstimatedBonus = employeeEstimatedBonus.filter(x => x[config.key]?.toLowerCase()?.includes(updateData[config.key]?.toLowerCase()?.trim()) === true);
      } else if (config.filterConfig && config.filterConfig.controlType === controlType.DropDown && updateData[config.key]) {
        employeeEstimatedBonus = employeeEstimatedBonus.filter(x => x[config.key]?.toLowerCase() === updateData[config.key]?.toLowerCase()?.trim());
      }
      return config;
    });
    this.setState({
      employeeEstimatedBonus: orderBy(employeeEstimatedBonus, this.state.orderBy, this.state.order)
    });
  }

  getColumns = (configuration, employeeEstimatedBonus) => {
    let columns = (UpdateColumnWithConfiguration(employeeBonusSheet, configuration) || []).filter(x => x.isVisible === true);
    const isFreezed = employeeEstimatedBonus.find(x => x.isFreezed === true)?.isFreezed || false;
    columns = columns.map(x => {
      if (isFreezed === true && x.isEditable === true && (x.dataFormat === 'DecimalPercent' || x.dataFormat === 'MoneyDecimal')) {
        x.type = 'Number';
      }
      return x;
    });
    return columns;
  }

  renderTable = (employeeEstimatedBonus, configuration) => {
    const columns = this.getColumns(configuration, employeeEstimatedBonus);
    const EditSource = [];
    EditSource.push(
      { key: 'departmentMasterData', data: this.state.departmentMasterData },
      { key: 'accountCodeNameMasterData', data: this.state.accountCodeNameMasterData },
      { key: 'designationMasterData', data: this.state.designationMasterData },
      { key: 'marketMasterData', data: this.state.marketMasterData }

    );
    return (
      <Table className="reportTable" id="rptTable">
        <EnhancedTableHead
          updateData={this.state.updateData}
          EditSource={EditSource}
          order={this.state.order}
          orderBy={this.state.orderBy}
          columnSequence={[]}
          onRequestSort={this.handleRequestSort}
          rowCount={employeeEstimatedBonus.length}
          headCells={columns}
          onFilterChange={this.onControlChange}
        />
        <TableBody>
          {this.renderTableCell(employeeEstimatedBonus, columns, [], 0)}
        </TableBody>
      </Table>
    );
  };

  isNumberKey = (evt) => {
    if (evt.target.value === '') {
      return true;
    } else {
      const numericInput = new RegExp(
        '^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,4}))))\\s*$'
      ); // '/^[0-9\b]+$/');
      return numericInput.test(evt.target.value);
    }
  }

  formatNumber = (value) => {
    const last = value?.charAt(value?.length - 1);
    if (last === '.' || last === '0' || (/^0*$/.test(value))) { return value; } else { return parseFloat(value); }
  }

  onChangeValues = (value, data, col, dataSource = []) => {
    const { employeeEstimatedBonus, originalEmployeeEstimatedBonus } = this.state;

    this.setState({
      employeeEstimatedBonus: this.prepareDataOnChange(employeeEstimatedBonus, data, col, value, dataSource),
      originalEmployeeEstimatedBonus: this.prepareDataOnChange(originalEmployeeEstimatedBonus, data, col, value, dataSource)
    });
  }

  prepareDataOnChange = (estimationData, data, col, value, dataSource) => {
    const valuePattern = RegExp(
      '^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,4}))))\\s*$'
    );
    estimationData.map(x => {
      if (x.employeeId === data.employeeId) {
        x[col.key] = isNaN(value) || !valuePattern.test(value) || value === '' ? 0 : this.formatNumber(value);
        if (col.appendText === 'amount') {
          x[col.calculatedFieldName] = parseFloat((x[col.key] / x.currentAnnualCompensation) * 100).toFixed(4);
          x.totalBonusAndBurdenRateAmount = parseFloat(parseFloat(x[col.key]) + (parseFloat(x[col.key]) * (x.burdenRatePercent / 100))).toFixed(4);
        } else if (col.appendText === 'percent') {
          x[col.calculatedFieldName] = parseFloat(x.currentAnnualCompensation * (parseFloat(x[col.key]) / 100)).toFixed(4);
          x.totalBonusAndBurdenRateAmount = parseFloat(parseFloat(x[col.calculatedFieldName]) + (parseFloat(x[col.calculatedFieldName]) * (x.burdenRatePercent / 100))).toFixed(4);
        } else {
          x[col.key] = value;
          x[col.calculatedFieldName] = parseFloat(x.currentAnnualCompensation * (parseFloat(x[col.calculatedFrom]) / 100)).toFixed(4);
          x.totalBonusAndBurdenRateAmount = parseFloat(parseFloat(x[col.calculatedFieldName]) + (parseFloat(x[col.calculatedFieldName]) * (x.burdenRatePercent / 100))).toFixed(4);
        }
        const selectedSourceData = dataSource.find(z => z[col.key] === value);
        if (col.editConfig.dependentField) {
          col.editConfig.dependentField.map(y => {
            x[y] = selectedSourceData ? selectedSourceData[y] : null;
            return y;
          });
        }
        if (col?.editConfig?.dependentFieldValidation) {
          col?.editConfig?.dependentFieldValidation.map(y => {
            const dependentField = employeeBonusSheet.find(dependentCol => dependentCol.key === y);
            x = (checkYearEndBonusValidations(dependentField, x, x[y]) || {}).x;
            return y;
          });
        }
        x = (checkYearEndBonusValidations(col, x, value) || {}).x;
      }
      return x;
    });
    return estimationData;
  }

  renderControl = (d, col, dataSource) => {
    const format = col.editConfig.type;
    const dropdownData = (dataSource.find(x => x.key === col.editConfig.sourceKey)?.data?.filter(
      x => this.state.originalEmployeeEstimatedBonus.find(z => z[col.editConfig.updateKey] === x[col.editConfig.updateKey]) === undefined
    ) || []);
    switch ((format || '').trim()) {
      case controlType.TextNumber:
        return <TextField
          value={d[col.key]}
          margin="normal"
          className={'amount-text editable'}
          error={d[col.key + 'IsInErrorState']}
          helperText={d[col.key + 'ErrorMessage']}
          size="small"
          color="primary"
          type='Number'
          onChange={(e) => this.isNumberKey(e) ? this.onChangeValues(e.target.value, d, col) : ''}
          InputProps={col.appendText === 'percent'
            ? {
              endAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>%</span></InputAdornment>
            }
            : {
              startAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>$</span></InputAdornment>
            }}
        />;
      case controlType.Badge:
        return <Chip
          className={d.isOverride === false && (d.bonusAmount?.toString() === '0' || d.bonusAmount?.toString() === '0.0000') ? 'no-title' : d.isOverride === true ? 'override' : 'no-override'}
          size="small"
          style={{ width: '40px', cursor: 'pointer' }}
          label={getFormattedValues(d[col.key], col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')}
          title={d.isOverride === false && (d.bonusAmount?.toString() === '0' || d.bonusAmount?.toString() === '0.0000') ? 'No Bonus Percent Adjusted Against Title' : d.isOverride === true ? 'Bonus Percent/Amount is Override' : 'No Bonus Percent/Amount is Override'}
        />;
      case controlType.DropDown:
        return (
          <>
            <Autocomplete
              size="small"
              error={d[col.key + 'IsInErrorState']}
              helperText={d[col.key + 'ErrorMessage']}
              options={dropdownData.map(
                (option) => option[col.editConfig.sourceOption]
              )}
              value={d[col.key]}
              className="editable"
              key={'dropDown_filter' + col.editConfig.updateKey}
              id={'dropDown_filter' + col.editConfig.updateKey}
              onChange={(event, value) => {
                this.onChangeValues(value, d, col, dropdownData);
              }}
              autoHighlight
              renderInput={(params) => (
                <TextField
                  disabled={col.isEditable}
                  error={d[col.key + 'IsInErrorState']}
                  helperText={d[col.key + 'ErrorMessage']}
                  {...params}
                  margin="normal"
                  className="table-text"
                />
              )}
            />
          </>
        );
    }
  }

  renderActionColumn = (d) => {
    return (<>{
      <Tooltip title="Delete Record">
        <IconButton
          aria-label={'refreshData'}
          size="small"
          onClick={() => {
            this.deleteRecord(d);
          }}
        >
          <DeleteIcon fontSize="small" size="small" />
        </IconButton>
      </Tooltip>
    }</>);
  }

  renderTableCell = (groupedData, columns, tableCell = [], rowCount = 0) => {
    const EditSource = [];
    EditSource.push(
      { key: 'employeeMasterData', data: this.state.employeeMasterData }
    );
    groupedData.forEach((d, i) => {
      const evenOddClass =
        tableCell.length % 2 === 0 ? ' rpt rpt-even ' : ' rpt rpt-odd ';
      const key = i + '_' + d.employeeBonusEstimationId + '_' + d.employeeId + '_' + d.departmentId + '_' + d.departmentId + '_' + rowCount + '_' + i;
      tableCell.push(
        <TableRow key={key} className={'rpt-topBorder'}>
          {
            columns.map((col, index) => {
              return (
                <>
                  <TableCell key={key + index} width={col.width || ''} className={evenOddClass + 'rpt-topBorder' + ' year-end-padding'} >
                    {col.isEditable === true && d.isFreezed !== true && col.editConfig !== undefined && col.editConfig.renderAlways === true
                      ? this.renderControl(d, col, EditSource)
                      : col.editConfig !== undefined && (col.editConfig.showBadge || (col.isEditable === true && d.isEditable === true && d.isFreezed === false && d.isRecentlyAdded === true))
                        ? this.renderControl(d, col, EditSource)
                        : col.renderComponent !== undefined && d.isFreezed === false && d.isEditable === true
                          ? this.renderActionColumn(d)
                          : col.editConfig !== undefined && col.editConfig.displayFormat !== undefined && col.editConfig.displayFormat === 'MultiText' && d.isRecentlyAdded !== true
                            ? this.renderBadge(d, col)
                            : getFormattedValues(d[col.key], col.dataFormat, false, undefined, undefined, undefined, undefined, false, false, false, undefined, 'Percent')
                    }

                  </TableCell>
                </>
              );
            })
          }

        </TableRow>
      );
      rowCount++;
    });
    if (groupedData?.length <= 0) {
      tableCell.push(<TableRow> <TableCell colSpan={8} align='center'>No records found</TableCell> </TableRow>);
    }
    return tableCell;
  }

  renderBadge = (d, col) => {
    const fieldArray = d[col.key].split('|');
    return fieldArray?.map(x => {
      return (
        <Chip
          key={d.employeeId + '_' + d.marketId}
          className={'info chip'}
          size="small"
          label={x}
          title={x || ''}
        />
      );
    });
  }

  deleteRecord = (d) => {
    let { deletedEmployeeBonusId, originalEmployeeEstimatedBonus, employeeEstimatedBonus } = this.state;
    if (d.employeeBonusEstimationId <= 0) {
      originalEmployeeEstimatedBonus = originalEmployeeEstimatedBonus.filter(x => x.employeeId !== d.employeeId);
      employeeEstimatedBonus = employeeEstimatedBonus.filter(x => x.employeeId !== d.employeeId);
    } else {
      deletedEmployeeBonusId.push(d.employeeBonusEstimationId);
      originalEmployeeEstimatedBonus = originalEmployeeEstimatedBonus.filter(x => x.employeeBonusEstimationId !== d.employeeBonusEstimationId);
      employeeEstimatedBonus = employeeEstimatedBonus.filter(x => x.employeeBonusEstimationId !== d.employeeBonusEstimationId);
    }
    this.setState({
      deletedEmployeeBonusId,
      originalEmployeeEstimatedBonus,
      employeeEstimatedBonus
    });
  }

  onFilterChange = (selectedData) => {
    if (selectedData.find((x) => x.key === 'startDate') === undefined ||
      selectedData.find((x) => x.key === 'startDate').selected === undefined ||
      selectedData.find((x) => x.key === 'startDate').selected?.length <= 0 || (
        selectedData.find((x) => x.key === 'startDate').selected?.length === 1 &&
        selectedData.find((x) => x.key === 'startDate').selected[0]?.startDate === 'Invalid date'
      )) {
      selectedData = selectedData.filter((x) => x.key !== 'startDate');
      selectedData.push({
        key: 'startDate',
        selected: [{ startDate: moment().format(DateFormat) }]
      });
    }
    this.setState({
      selectedData
    }, () => {
      this.GetEmployeeBonusEstimation(selectedData);
    });
  }

  onConfirmClickHandle = (value) => {
    if (value) {
      this.setState({
        openDialog: false,
        confirmationMessage: ''
      }, () => {
        this.saveEmployeeSheet();
      });
    } else {
      this.setState({
        openDialog: false,
        confirmationMessage: '',
        resetDefault: false
      });
    }
  }

  saveEmployeeSheet = () => {
    const { selectedData } = this.state;
    let startDate = null;
    const startDateData =
      selectedData.find((x) => x.key === 'startDate') || {};
    if (
      startDateData &&
      startDateData.selected &&
      startDateData.selected.length > 0
    ) {
      startDate = startDateData.selected[0].startDate;
    }
    apiPut(API_URL.Employee.UpdateEmployeeBonusEstimation, this.state.originalEmployeeEstimatedBonus, {
      resetDefault: this.state.resetDefault,
      deleteBonusEstimationId: this.state.deletedEmployeeBonusId.join('|'),
      processYear: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year()
    }).then(({ data: response }) => {
      if (response.success) {
        ShowToast('Employee Yearly Bonus updated successfully', toastType.SUCCESS, 5000, 500);
        this.GetEmployeeBonusEstimation(this.state.selectedData);
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 500);
      }
    });
  }

  onSubmitClick = (isReset = false) => {
    const formData = isReset === false ? this.isValidForm(this.state.originalEmployeeEstimatedBonus, this.state.employeeEstimatedBonus) : '';
    if (formData !== '' && formData.isValid === false) {
      this.setState({
        employeeEstimatedBonus: formData.employeeEstimatedBonus,
        originalEmployeeEstimatedBonus: formData.originalEmployeeEstimatedBonus
      });
    } else {
      this.setState({
        openDialog: true,
        resetDefault: isReset,
        confirmationMessage: isReset === true ? 'Do you want to reset Employee Yearly Bonus Estimations? If yes, then this will consider Bonus Percent from Configure Bonus against the Title Configuration Screen and also delete all the reviewed/Accrued entries.' : 'Do you want to save Employee Yearly Bonus?'
      });
    }
  }

  prepareDataForFinalSave = (data) => {
    let formData = null;
    let isValid = true;
    data.map(x => {
      let rowInvalid = true;
      employeeBonusSheet.map(z => {
        formData = checkYearEndBonusValidations(z, x, x[z.key]);
        x = formData.x;
        if (isValid === true) {
          isValid = formData.isValid;
        }
        if (rowInvalid === true) {
          rowInvalid = formData.isValid;
        }
        return z;
      });
      x.isRecentlyAdded = !rowInvalid;
      return x;
    });
    return { data, isValid };
  }

  isValidForm = (originalEmployeeEstimatedBonus, employeeEstimatedBonus) => {
    let formData = null;
    formData = this.prepareDataForFinalSave(originalEmployeeEstimatedBonus);
    employeeEstimatedBonus = (this.prepareDataForFinalSave(employeeEstimatedBonus) || {}).data;

    if (formData.isValid === false) {
      ShowToast('Please enter valid data in field(s).', toastType.ERROR, 5000, 500);
    }

    return { isValid: formData.isValid, employeeEstimatedBonus, originalEmployeeEstimatedBonus: formData.data };
  }

  AddEmployeeForYearEndBonus = () => {
    const { originalEmployeeEstimatedBonus, employeeEstimatedBonus, selectedData } = this.state;
    const formData = this.isValidForm(originalEmployeeEstimatedBonus, employeeEstimatedBonus);
    if (formData.isValid === false) {
      this.setState({
        employeeEstimatedBonus: formData.employeeEstimatedBonus,
        originalEmployeeEstimatedBonus: formData.originalEmployeeEstimatedBonus
      });
    } else {
      let startDate = null;
      const startDateData =
        selectedData.find((x) => x.key === 'startDate') || {};

      if (
        startDateData &&
        startDateData.selected &&
        startDateData.selected.length > 0
      ) {
        startDate = moment(startDateData.selected[0].startDate).format(DateFormat);
      } else {
        startDate = moment().format(DateFormat);
      }
      const addNew = {
        isEditable: true,
        bonusAmount: 0,
        bonusPercent: 0,
        burdenRatePercent: 0,
        currentAnnualCompensation: 0,
        departmentId: 0,
        departmentName: '',
        designation: '',
        designationId: 0,
        division: null,
        divisionId: 0,
        employeeBonusEstimationId: 0,
        employeeId: 0,
        expenseAccount: null,
        expenseAccountId: 0,
        isFreezed: false,
        isOverride: false,
        preferredName: null,
        statusId: 1,
        totalBonusAndBurdenRateAmount: 0,
        processYear: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year(),
        isRecentlyAdded: true
      };
      formData.originalEmployeeEstimatedBonus.unshift(addNew);
      formData.employeeEstimatedBonus.unshift(addNew);
      this.setState({
        employeeEstimatedBonus: formData.employeeEstimatedBonus,
        originalEmployeeEstimatedBonus: formData.originalEmployeeEstimatedBonus,
        isValid: false
      });
    }
  }

  downloadFile = (fileMimeType, type, isPrint = false) => {
    const { selectedData } = this.state;
    let startDate = null;
    const marketName =
      selectedData.find((x) => x.key === 'marketName') || {};
    let marketId = null;
    if (
      marketName &&
      marketName.selected &&
      marketName.selected.length > 0
    ) {
      marketId = marketName.selected.map(x => x.marketId).join('|');
    }
    const startDateData =
      selectedData.find((x) => x.key === 'startDate') || {};
    if (
      startDateData &&
      startDateData.selected &&
      startDateData.selected.length > 0
    ) {
      startDate = startDateData.selected[0].startDate;
    }
    const dataValue = [
      {
        key: 'ProcessYear',
        value: moment(moment(startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year()
      },
      {
        key: 'MarketId',
        value: marketId === null || marketId?.length <= 0 ? '0' : marketId
      }
    ];
    const url = GenerateAbsoluteURL(dataValue, [], 'EmployeeYearlyBonusEstimations', type, false, true);

    downloadReport(
      url,
      'Employee Yearly Bonus Estimations',
      fileMimeType,
      type,
      isPrint
    );
  }

  render() {
    const {
      employeeEstimatedBonus,
      configuration,
      selectedData,
      defaultSelectedData,
      showReport,
      isFreezed,
      employeeMasterData,
      marketMasterData
    } = this.state;

    const filterConfig = [
      {
        type: controlType.Year,
        key: 'startDate',
        placeholder: 'Search Year',
        title: 'Year',
        clearable: false,
        dontFilterOtherSource: true
      },
      {
        multiple: true,
        type: controlType.DropDown,
        source: marketMasterData,
        key: 'marketName',
        placeholder: 'Search Market',
        title: 'Market'
      }
    ];
    console.log(marketMasterData);
    return (
      <div>
        {(
          <>
            <ConfirmDialog
              IsOpen={this.state.openDialog}
              Message={this.state.confirmationMessage}
              OnHandelClick={(isValid) => {
                if (isValid) {
                  this.onConfirmClickHandle(isValid);
                } else {
                  this.onConfirmClickHandle(isValid);
                }
              }}
              AgreeText="Yes"
              DisAgreeText="No"
            />
            <PageHeader title="Employee Yearly Bonus"></PageHeader>
            <PageFilter
              autoFilter={false}
              hidePanel={true}
              filterAlwaysVisible={true}
              onFilterChanged={this.onFilterChange}
              filterConfig={filterConfig}
              defaultSelectedData={defaultSelectedData}
              selectedData={selectedData}
              gridColumn={3}
            />
            {(
              <div>
                {(
                  <>
                    {showReport === false &&
                      (employeeEstimatedBonus == null ||
                        employeeEstimatedBonus.length <= 0) && (
                        <Grid container spacing={4}>
                          <Grid
                            container
                            direction="row-reverse"
                            justify="center"
                            alignItems="stretch"
                          >
                            <label className="item-big">No Data Available.</label>
                          </Grid>
                        </Grid>
                      )}
                    <div className="col-xs-12 col-lg-12 filter-action-group">
                      <div className="row end-xs">
                        {showReport === true && isFreezed === false && employeeEstimatedBonus !== null && employeeEstimatedBonus?.length > 0 && <div className="row col-xs-4 col-sm-4">
                          <div className="col-xs-12 col-sm-12 no-padding start-xs">
                            <span>
                              <Button
                                className='legend-btn no-title'
                                variant="contained"
                              />
                            </span> &nbsp;&nbsp;
                                <span>
                              No Bonus Percent Adjusted Against Title
                                </span>
                          </div>
                          <div className="col-xs-12 col-sm-12 no-padding start-xs">
                            <span>
                              <Button
                                className='legend-btn override'
                                variant="contained"
                              />
                            </span> &nbsp;&nbsp;
                              <span>
                              Bonus Percent/Amount is Override
                              </span>
                          </div>
                          <div className="col-xs-12 col-sm-12 no-padding start-xs">
                            <span>
                              <Button
                                className='legend-btn no-override'
                                variant="contained"
                              />
                            </span> &nbsp;&nbsp;
                              <span>
                              No Bonus Percent/Amount is Override
                              </span>
                          </div>
                        </div>}
                        <div className="row col-xs-8 col-sm-8 no-padding end-xs">
                          {showReport === true && isFreezed === false && employeeMasterData?.length > 0 && <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => { this.AddEmployeeForYearEndBonus(); }}
                          >
                            Add Employee
                              </Button>} &nbsp;&nbsp;
                              {showReport === true && isFreezed === false && employeeEstimatedBonus !== null && employeeEstimatedBonus?.length > 0 && <><Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<ResetIcon />}
                            onClick={() => { this.onSubmitClick(true); }}
                          >
                            Reset Default Employee Yearly Bonus
                              </Button> &nbsp;&nbsp;
                              <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              startIcon={<SaveIcon />}
                              onClick={() => { this.onSubmitClick(); }}
                            >
                              Save Employee Yearly Bonus
                              </Button>  </>}
                              &nbsp;&nbsp;
                             {this.state.originalDBEmployeeEstimatedBonus.length > 0 &&
                            <Tooltip title="Export Excel">
                              <IconButton
                                size="small"
                                onClick={() => this.downloadFile('application/vnd.ms-excel', 'Excel')}>
                                <div style={{ fontSize: '1.5rem', color: '#05375E' }}>
                                  <AssignmentIcon />
                                </div>
                              </IconButton>
                            </Tooltip>}
                        </div>
                      </div>
                    </div>
                    {showReport === true &&
                      <div className="container year-end-bonus" style={{ marginTop: '1rem' }}>
                        {this.renderTable(employeeEstimatedBonus, configuration)}
                      </div>
                    }
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}
